import { render, staticRenderFns } from "./group_standard_group_equipment.vue?vue&type=template&id=06f8716d&scoped=true&"
import script from "./group_standard_group_equipment.vue?vue&type=script&lang=js&"
export * from "./group_standard_group_equipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8716d",
  null
  
)

export default component.exports